import React from 'react';
import PropTypes from 'prop-types';

export const SvgWallet = ({ width, height, stroke }) => (
  <svg width={width || '18px'} height={height || '16px'} viewBox="0 0 18 16" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-33.000000, -192.000000)">
        <g id="Group-14" transform="translate(15.000000, 170.000000)">
          <g transform="translate(15.000000, 18.000000)">
            <path
              d="M7.83333333,8.01268202 L17.8,8.01268202 C18.7388841,8.01268202 19.5,8.77379795 19.5,9.71268202 L19.5,17.25 L19.5,17.25 C19.5,18.2164983 18.7538079,19 17.8333333,19 L6.16666667,19 C5.24619208,19 4.5,18.2164983 4.5,17.25 L4.5,9.41647183 M4.5,9.44903261 L4.5,6.75 C4.5,5.78350169 5.24619208,5 6.16666667,5 L16.1666667,5 C17.0871412,5 17.8333333,5.78350169 17.8333333,6.75 L17.8333333,8.01297246"
              stroke={stroke || '#000000'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.6040573,14.976341 C16.3772559,14.976341 17.0040573,14.3181996 17.0040573,13.506341 C17.0040573,12.6944824 16.3772559,12.036341 15.6040573,12.036341 C14.8308586,12.036341 14.2040573,12.6944824 14.2040573,13.506341 C14.2040573,14.3181996 14.8308586,14.976341 15.6040573,14.976341 Z"
              fill={stroke || '#000000'}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

SvgWallet.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
